import React, { ReactNode } from 'react';
import { createPortal } from 'react-dom';

type PortalProps = {
  children: ReactNode;
  portalId: string;
};

export const Portal: React.FC<PortalProps> = ({
  children,
  portalId,
}: PortalProps) => {
  const portalRoot = document.getElementById(portalId);
  if (!portalRoot) return null;
  return createPortal(children, portalRoot);
};
